<template>
  <div class="one-column-view">
    <div class="article-content">
      <div class="career-banner p-0 m-0 mb-3 w-100">
        <img src="../assets/career.png" alt="Career" class="w-auto m-0 h-100" />
      </div>
      <h1>Be Part of Something Big</h1>
      <p>
        Our mission is to create a more human place on the Internet, where
        businesses and marketers from all over the world come together to
        promote products, engage in dialogue, make new connections, learn new
        things, and earn!
      </p>
      <h1>JOIN US!</h1>
      <p>
        We are a highly creative and cohesive IT team, shouldering the great
        mission of win-win on the Internet.
      </p>
      <p>
        Creativity and consensus are closely linked, but because of the distance
        of thinking, consensus is not so easy to achieve. If you want to seize
        such an opportunity, please join us!
      </p>
      <p>
        Apply now. Together we challenge an opportunity to fulfill our mission.
        The world of web 3, win, win, win!
      </p>
      <p>
        If you have excellent blockchain IT skills, as well as industry
        experience, creativity, and our shared goals, you are exactly what we
        are looking for, please review and submit your resume below:
      </p>
      <div class="d-flex flex-column flex-md-row justify-content-start align-items-start align-items-md-center gap-3 mb-3">
        <h4 class="text-dark m-0"><strong>Marketing Content Writer</strong></h4>
        <router-link
          to="/pages/careers-writer"
          class="btn btn-gold text-white"
          >{{ $t("careers.submitResume") }}</router-link
        >
      </div>
      <div class="d-flex flex-column flex-md-row justify-content-start align-items-start align-items-md-center gap-3 mb-3">
        <h4 class="text-dark m-0">
          <strong>Digital Content Specialist</strong>
        </h4>
        <router-link
          to="/pages/careers-specialist"
          class="btn btn-gold text-white"
          >{{ $t("careers.submitResume") }}</router-link
        >
      </div>
      <div class="d-flex flex-column flex-md-row justify-content-start align-items-start align-items-md-center gap-3 mb-3">
        <h4 class="text-dark m-0"><strong>Blockchain Developer</strong></h4>
        <router-link
          to="/pages/careers-developer"
          class="btn btn-gold text-white"
          >{{ $t("careers.submitResume") }}</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
};
</script>

<style scoped>
.career-banner {
  height: 336px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
</style>
